import {
  CommandBar,
  DetailsHeader,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  IColumn,
  ICommandBarItemProps,
  IDetailsHeaderStyles,
  IDetailsListProps,
  IDetailsListStyles,
  IDetailsRowStyles,
  MarqueeSelection,
  SelectionMode,
  Stack,
} from "@fluentui/react";
import { CSSProperties, useEffect, useRef, useState } from "react";
import themeBase from "../../utils/theme/themeBase";
import { LineProgress } from "../indicadores/Load";
import { Selection } from "@fluentui/react";

interface ITableV8 {
  style?: CSSProperties;
  rigthBar?: ICommandBarItemProps[];
  leftBar?: ICommandBarItemProps[];
  isLoading: boolean;
  data: any[];
  column: IColumn[];
  footerPagination?: JSX.Element | undefined;
  selectionMode: SelectionMode;
  selection?: Selection;
}

export const TableV8 = (props: ITableV8) => {
  const [tableHeight, setTableHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setTableHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const _tableStyle: Partial<IDetailsListStyles> = {
    root: {
      overflowX: "scroll",
      // border: "solid 1px blue",
      selectors: {
        "& [role=grid]": {
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          height: tableHeight - 225,
        },
      },
    },
    headerWrapper: {
      margin: "0 0 1px 0",
      paddingTop: "0px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Cambia esto según tus necesidades
      flex: "0 0 auto",
    },
    contentWrapper: {
      flex: "1 1 auto",
      overflowY: "auto",
      overflowX: "hidden",
    },
  };

  return (
    <div style={props.style} key="superDivCMD">
      {(props.rigthBar || props.leftBar) && (
        <div key="superBajDivCMD" className="ms-Grid-col ms-sm12 ms-lg12">
          <CommandBar
            items={props.leftBar ? props.leftBar : []}
            farItems={props.rigthBar}
            styles={themeBase.commadStyles}
            key="cmdBTV8"
          />
        </div>
      )}
      <Stack>
        <div key="stkln" className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <LineProgress key="lpsk" disabled={!props.isLoading} />
          {!props.isLoading && (
            <>
              <MarqueeSelection selection={props.selection!}>
                <DetailsList
                  key={"dltv8"}
                  items={props.data}
                  compact={true}
                  columns={props.column}
                  selectionMode={props.selectionMode}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  selectionPreservedOnEmptyClick={true}
                  enterModalSelectionOnTouch={true}
                  ariaLabelForSelectionColumn="Toggle selection"
                  ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                  checkButtonAriaLabel="select row"
                  styles={_tableStyle}
                  onRenderRow={_onRenderRow}
                  onRenderDetailsHeader={_onRenderDetailsHeader}
                  selection={props.selection}
                  // onRenderCheckbox={onRenderCheckbox}
                />
              </MarqueeSelection>

              {props.footerPagination && (
                <div
                  key="ftrTV"
                  style={{
                    bottom: 0,
                  }}
                >
                  <div
                    key="ftPag"
                    className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
                  >
                    {props.footerPagination}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </Stack>
    </div>
  );
};
const _onRenderDetailsHeader: IDetailsListProps["onRenderDetailsHeader"] = (
  props
) => {
  const customStyles: Partial<IDetailsHeaderStyles> = {};
  customStyles.root = {
    paddingTop: "0px",
    textAlign: "",
  };
  if (props) {
    return <DetailsHeader key={"headerTV8"} {...props} styles={customStyles} />;
  }
  return null;
};

const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
  const customStyles: Partial<IDetailsRowStyles> = {};
  if (props) {
    customStyles.root = {
      width: "100%",
      margin: "0 0 0 0",
    };
    return (
      <DetailsRow
        key={"dr"}
        {...props}
        styles={customStyles}
        // checkboxVisibility={
        //   props.item.isFolder != undefined && props.item.isFolder ? false : true
        // }
        // onRenderCheck={(checkboxProps) =>
        //   onRenderCheckbox({ ...checkboxProps, item: props.item })
        // }
      />
    );
  }
  return null;
};
function selectionChangedHandler() {
  throw new Error("Function not implemented.");
}
